<template>
  <div class="c-base-otp-input">
    <input
      v-for="(digit, index) in digits"
      :key="index"
      :class="{ 'is-error': hasInvalidFormat || hasError }"
      type="text"
      maxlength="1"
      class="otp-digit"
      v-model="digit.value"
      @click="clear(index)"
      @input="onInput(index, $event)"
      @keydown.backspace="onBackspace(index, $event)"
      v-on:keyup.enter="$emit('submit')"
      ref="otpInputs"
      :autofocus="autofocus && index === 0"
    />
  </div>
</template>

<script>
export default {
  props: {
    length: {
      type: Number,
      default: 6,
    },
    value: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasInvalidFormat() {
      const regex = /^\d+$/
      return !regex.test(this.value) && this.value.length > 0
    },
  },
  data() {
    return {
      digits: Array.from({ length: this.length }, () => ({ value: '' })),
    }
  },
  watch: {
    value(newVal) {
      if (newVal.length === this.length) {
        this.digits = newVal.split('').map((digit) => ({ value: digit }))
      }
    },
  },
  methods: {
    clear(index) {
      this.digits[index].value = ''
      this.$emit('input', this.digits.map((digit) => digit.value).join(''))
    },
    onInput(index, event) {
      const value = event.target.value

      this.digits[index].value = value

      this.$emit('input', this.digits.map((digit) => digit.value).join(''))

      if (
        index < this.length - 1 &&
        event.inputType !== 'deleteContentBackward'
      ) {
        this.$refs.otpInputs[index + 1].focus()
      }
    },
    onBackspace(index, event) {
      if (event.target.value === '') {
        if (index > 0) {
          this.digits[index - 1].value = ''
          this.$refs.otpInputs[index - 1].focus()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-otp-input {
  display: flex;
  justify-content: space-between;
  min-width: 140px;

  .otp-digit {
    width: 32px;
    height: 32px;
    font-size: 16px;
    color: $neutral;
    text-align: center;
    border-radius: 8px;
    border: 1px solid rgba($neutrallight, 0.5);
    &:hover {
      border-color: $neutrallight;
    }
    &:focus,
    &:active {
      border-color: $neutrallight;
      box-shadow: 0px 0px 3px 0px $neutrallight;
      outline: none;
    }
    &.is-error {
      border-color: $error;
      box-shadow: none;
    }
    &:disabled {
      color: #cbcbcb;
      cursor: not-allowed;
      pointer-events: none;
      border-color: #f3f3f3;
      background-color: #f3f3f3;
    }
  }
}
</style>
